export const CheckForSQL = input => {
	let sqlReqExp = /('|"|\*|=|;|\s)/
	
	return sqlReqExp.test(input)
}